import Api from '@op/opds.api-base';
import apiBaseLog from '@op/opds.api-base/log';
import { type RavenStatic } from 'raven-js/typescript/raven';
import { getCurrentLanguage } from '../i18n';

// TODO: When '/rest' is removed from LIFEPURCHASE_SERVICE_API_URL in config,
//  this function can be removed.
const removeRestSuffix = (input: string): string =>
  input.replace(/\/rest$/, '');

const loggingApi = new Api(
  removeRestSuffix(window.__RHVKLSO002_CONFIG.LIFEPURCHASE_SERVICE_API_URL),
  {
    acceptLanguages: [getCurrentLanguage()],
  }
);

const log = apiBaseLog as typeof apiBaseLog & RavenStatic;
log.config(loggingApi);

interface Logger {
  logError: (error: Error) => void;
  logErrorFromRequest: (error: Error, request: string) => void;
}

export const logger: Logger = {
  logError: (error: Error) => {
    log.captureException(error, { level: 'error' });
  },
  logErrorFromRequest: (error: Error, request: string) => {
    // @ts-expect-error missing typings
    log.captureException(error, { level: 'error', request });
  },
};
